
import { hydrateCSRTemplate } from '@fiverr-private/layout_lib/CSRTemplate';
import { handleCSRError } from '@fiverr-private/layout_lib/CSRTemplate';
import { loader } from '/home/circleci/app/packages/layout-sidebar-component/src/entries/Guest';
const getRootElement = () => typeof document !== 'undefined' && document.querySelector('#Sidebar');
const lazyImport = () => import(
    /* webpackChunkName: "GuestLazyComponent" */
    /* webpackExports: ["default"] */
    '/home/circleci/app/packages/layout-sidebar-component/src/entries/Guest?version=1'
);
const hydrateComponent = async () => {
    try {
        const { default: Component } = await lazyImport();
        const props = window.initialData['Sidebar'];
        const root = getRootElement();
        if (root) {
            hydrateCSRTemplate(Component, props, root, 'Sidebar', 'Guest');
        }
    } catch(error) {
        handleCSRError(error, "Sidebar", "Guest");
    }
};
const main = async () => {
    try {
        const root = getRootElement();
        if (root) {
            await loader(hydrateComponent, root);
        }
    } catch(error) {
        handleCSRError(error, "Sidebar", "Guest");
    }
};
main();
export default main;
